import { RestService } from '@abp/ng.core';
import { Injectable, Injector, inject } from '@angular/core';

export type GuardedDeletionEntity = 'cycles' | 'rotations' | 'interventions' | 'stand-transformation-histories' | 'wood-certifications' | 'protected-areas' | 'pipeline-properties' | 'pipeline-stands' | 'pipeline-planned-plantation-headers' | 'pipeline-planned-plantations' | 'official-planned-plantation-headers' | 'official-planned-plantations' | 'incidents' | 'stands';

@Injectable({ providedIn: 'root' })
export class GuardedDeletionService {
  private readonly injector = inject(Injector);

  deleteByIds(entity: GuardedDeletionEntity, ids: number[]) {
    return this.injector.get(RestService).request<number[], void>({
      method: 'DELETE',
      url: `/api/orchestrator/planning/${entity}`,
      body: [...new Set(ids)],
    }, { apiName: 'Orchestrator' });
  }
}
